<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>无数据商品列表</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row
      v-if="filter"
      class="row"
      :gutter="20"
      type="flex"
      align="middle"
      justify="space-around"
    >
      <el-col
        v-for="item in filter.optionOrigin"
        :key="item.key"
        :span="24 / filter.optionOrigin.length"
        class="column"
      >
        <div
          class="status"
          :class="{ active: origin == item.key }"
          @click="selectStatus(item.key)"
        >
          {{ item.label }}
        </div>
      </el-col>
    </el-row>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="">
                  <el-select v-model="form.select_type">
                    <el-option
                      v-for="item in select_type_option"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.select_type_value"
                    placeholder="请输入查询的内容"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.supply_name"
                    placeholder="请输入商家"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="代采组">
                  <el-select
                    v-model="form.pgid"
                    filterable
                    multiple
                    placeholder="代采组"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in filter.optionPg"
                      :key="item.value"
                      :value="item.key"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="代采员">
                  <el-select
                    v-model="form.pg_member_id"
                    filterable
                    multiple
                    placeholder="代采员"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in filter.optionPgMember"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="是否拦截">
                  <el-select v-model="form.is_stop">
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="item in filter.optionIsStop"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="状态">
                  <el-select v-model="form.handle_state" placeholder="状态">
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in filter.optionHandleState"
                      :key="item.key"
                      :value="item.key"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="点货类型">
                  <el-select v-model="form.dh_type" placeholder="点货类型">
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="item in filter.optionDhType"
                      :key="item.key"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="不良品类型">
                  <el-select v-model="form.blp_type" placeholder="不良品类型">
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in filter.optionBlpType"
                      :key="item.key"
                      :value="item.key"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="创建时间：">
                  <el-date-picker
                    v-model="form.time"
                    :default-time="['06:00:00', '06:00:00']"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="处理时间：">
                  <el-date-picker
                    v-model="form.handle_time"
                    :default-time="['06:00:00', '06:00:00']"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="包裹类型">
                  <el-select
                    v-model="form.package_type"
                    filterable
                    placeholder="包裹类型"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option label="大货" value="1"></el-option>
                    <el-option label="备货" value="2"></el-option>
                    <el-option label="前置仓" value="3"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="是否核实">
                  <el-select
                    v-model="form.is_verify"
                    filterable
                    placeholder="是否核实"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option label="是" value="1"></el-option>
                    <el-option label="否" value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="退还方式">
                  <el-select
                    v-model="form.return_mode"
                    filterable
                    placeholder="退还方式"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option label="市场退回" value="1"></el-option>
                    <el-option label="快递寄回" value="2"></el-option>
                    <el-option label="移交次品员" value="3"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="退还快递单号">
                  <el-input
                    v-model="form.shipping_num"
                    placeholder="快递单号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="次品员">
                  <el-select
                    v-model="form.dg_member_ids"
                    filterable
                    multiple
                    placeholder="代采组"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in filter.optionDgMember"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>
            <el-button size="small" @click="stopRows(0)">
              批量拦截/不拦截</el-button
            >
            <el-button size="small" @click="showNdgDialog(1)">
              移交代采</el-button
            >
            <el-button size="small" @click="showNdgDialog(2)">
              放行退还打包</el-button
            >
            <el-button size="small" @click="recall_dialog = true">
              撤回包裹号
            </el-button>
            <el-button size="small" @click="showReturnShippingModal">
              填写退还快递单号
            </el-button>
            <el-button size="small" @click="handleBatchWithdraw">
              批量撤回放行退还
            </el-button>
          </div>
          <el-button
            style="margin-left: auto"
            type="success"
            size="mini"
            @click="output"
            >导出</el-button
          >
        </div>
        <div style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            border
            @selection-change="handleSelectionChange"
          >
            <el-table-column align="center" type="selection"> </el-table-column>
            <el-table-column
              prop="ndgid"
              label="无数据标id"
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="pici_no"
              label="批次单"
              align="center"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="package_no"
              label="包裹号"
              align="center"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="package_type"
              label="包裹类型"
              align="center"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="supply_name"
              label="商家"
              align="center"
              width="100"
            >
            </el-table-column>

            <el-table-column
              prop="pgname"
              label="代采组"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pg_member_name"
              label="代采员"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="no_data_reason_text"
              label="无数据理由"
              show-overflow-tooltip
              align="center"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="goods_kh"
              label="款号"
              show-overflow-tooltip
              align="center"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="co_si_val"
              label="颜色/尺码"
              show-overflow-tooltip
              align="center"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="dg_member_name"
              label="次品员"
              show-overflow-tooltip
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="admin_name"
              label="创建人"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="创建时间"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="note"
              label="备注"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="handle_state_text"
              label="状态"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="is_verify_text"
              label="是否核实"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="verify_text"
              label="核实信息"
              align="center"
              width="150"
            >
              <template #default="{ row }">
                <div v-if="row.verify_text">
                  <el-tooltip>
                    <div slot="content">
                      <div
                        v-for="text in row.verify_text.split('\n')"
                        :key="text"
                      >
                        {{ text }}
                      </div>
                    </div>
                    <div>
                      <div
                        v-for="text in row.verify_text.split('\n')"
                        :key="text"
                        style="overflow: hidden; text-overflow: ellipsis"
                      >
                        {{ text }}
                      </div>
                    </div>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="image_turn_over_arr"
              label="移交代采图片(多图)"
              align="center"
            >
              <template #default="{ row }">
                <img
                  v-if="row.image_turn_over_arr[0]"
                  :src="row.image_turn_over_arr[0]"
                  alt=""
                  style="width: 80px; height: 80px"
                  @click="handleViewImages(row.image_turn_over_arr)"
                />
              </template>
            </el-table-column>
            <el-table-column
              prop="dbid"
              label="打标id"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="handle_admin_name"
              label="处理人"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="dh_type"
              label="点货类型"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="blp_type"
              label="不良品类型"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="blp_note"
              label="不良品备注"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="invalid_note"
              label="作废理由"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="handle_time"
              label="处理时间"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="return_mode_str"
              label="退还方式"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="return_note"
              label="退还备注"
              align="center"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column label="快速寄回收件信息" width="200px">
              <template #default="scope">
                <div style="white-space: pre-line">
                  {{
                    scope.row.return_express_info
                      ? scope.row.return_express_info
                      : "-"
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="no_data_package_no"
              label="无数据包裹号"
              align="center"
              width="160px"
            >
            </el-table-column>
            <el-table-column
              prop="package_img_arr"
              label="包裹图片"
              align="center"
            >
              <template #default="{ row }">
                <img
                  v-if="row.package_img_arr[0]"
                  :src="row.package_img_arr[0]"
                  alt=""
                  style="width: 80px; height: 80px"
                  @click="handleViewImages(row.package_img_arr)"
                />
              </template>
            </el-table-column>
            <el-table-column
              prop="shipping_num"
              label="退还快递单号"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="signing_time"
              label="签收时间"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="signing_name"
              label="签收人"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="deliver_time"
              label="妥投时间"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="deliver_phone"
              label="妥投手机号"
              align="center"
            ></el-table-column>
            <el-table-column prop="deliver_img" label="妥投图" align="center">
              <template #default="{ row }">
                <img
                  v-if="row.deliver_img && row.deliver_img.length > 0"
                  :src="row.deliver_img[0]"
                  alt=""
                  style="width: 80px; height: 80px"
                  @click="handleViewImages(row.deliver_img)"
                /> </template
            ></el-table-column>
            <el-table-column
              prop="supply_signing_time"
              label="商家签收时间"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="supply_signing_name"
              label=" 商家签收人"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="signing_phone"
              label="签收手机号"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="buyer_datetime"
              label="提交代采时间"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="return_datetime"
              label="提交退还时间"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="return_admin_name"
              label="提交退还人"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="verify_time"
              label="代采核实时间"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="verify_admin_name"
              label="核实人"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="withdraw_time"
              label="撤回退还时间"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="pack_datetime"
              label="退还打包时间"
              align="center"
            ></el-table-column>
            <el-table-column
              label="操作"
              align="center"
              fixed="right"
              width="200px"
            >
              <template #default="scope">
                <el-switch
                  v-model="scope.row.is_stop"
                  :disabled="!['1', '2'].includes(scope.row.handle_state)"
                  active-value="1"
                  inactive-value="2"
                  active-text="拦截"
                  inactive-text="不拦截"
                  @change="stopRow(scope.$index)"
                ></el-switch>
                <el-button
                  type="text"
                  :disabled="!['1', '2'].includes(scope.row.handle_state)"
                  style="margin-left: 10px"
                  @click="discard(scope.row)"
                  >做废</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="form.page"
            :page-size.sync="form.page_size"
            background
            layout="total, prev, pager, next, jumper, sizes"
            :total="resData.count"
            :page-sizes="[50, 100, 200, 500]"
            @current-change="fetchData"
            @size-change="
              (size) => {
                form.page_size = size;
                search();
              }
            "
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :visible.sync="ndg_dialog.show"
      :title="
        ndg_dialog.type === ConstEnum.transfer
          ? '无数据移交代采'
          : '无数据商品——放行退还打包'
      "
      width="660px"
      :close-on-click-modal="false"
      @close="clearRecallList"
    >
      <template>
        <H4
          v-if="
            ndg_dialog.type === ConstEnum.sendBack && supplyInfo.supply_name
          "
          >商家名称：{{ supplyInfo.supply_name }}</H4
        >
        <H4
          v-if="
            ndg_dialog.type === ConstEnum.sendBack &&
            supplyInfo.return_mode_text
          "
          >退还方式：{{ supplyInfo.return_mode_text }}</H4
        >
      </template>
      <el-row :gutter="20">
        <el-col :span="16">
          <el-input
            ref="scanNdgidRef"
            v-model="ndg_dialog.value"
            style="width: 100%"
            placeholder="扫描/输入无数据ID"
            @keyup.native.enter="scanPush"
          ></el-input
          >&nbsp;&nbsp;&nbsp;
        </el-col>
        <el-col :span="8">
          <el-row>
            <el-col :span="12">
              <el-button type="primary" @click="scanPush">确定</el-button>
            </el-col>
            <el-col :span="12">
              <el-upload
                v-if="ndg_dialog.type === ConstEnum.transfer"
                :before-upload="beforeImport"
                :on-success="handleImport"
                :action="action"
                :show-file-list="false"
                with-credentials
              >
                <el-button type="success">导入</el-button>
              </el-upload>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <template
        v-if="ndg_dialog.type === ConstEnum.transfer || ConstEnum.sendBack"
      >
        <el-table
          :data="ndg_dialog.scan"
          border
          max-height="400"
          :row-class-name="tableRowClassName"
          >>
          <el-table-column
            label="无数据ID"
            prop="ndgid"
            align="center"
            width="100px"
          ></el-table-column>
          <el-table-column
            v-if="ndg_dialog.type === ConstEnum.transfer"
            label="上传图片（至少一张，最多五张）"
            prop="images"
            align="center"
          >
            <template #default="{ row, $index }">
              <div
                v-viewer="row.images"
                style="display: flex; flex-direction: row"
              >
                <div
                  v-for="(item, i) in row.images"
                  :key="item.name"
                  style="
                    position: relative;
                    width: 60px;
                    height: 60px;
                    margin: 4px;
                  "
                >
                  <img
                    :src="item.url"
                    alt=""
                    style="width: 100%; height: 100%"
                  />
                  <i
                    class="el-icon-circle-close"
                    style="
                      position: absolute;
                      top: -4px;
                      right: -4px;
                      font-size: 14px;
                      color: red;
                    "
                    @click="handleDelImages($index, i)"
                  />
                </div>
                <span
                  style="
                    width: 60px;
                    height: 60px;
                    margin: 4px;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    border: 1px solid #ccc;
                  "
                  @click="handleEditImages(row, $index)"
                >
                  <i class="el-icon-plus" />
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-if="ndg_dialog.type === ConstEnum.sendBack"
            label="图片"
            prop="images"
            align="center"
          >
            <template #default="{ row }">
              <div
                v-viewer="row.images"
                style="display: flex; flex-direction: row"
              >
                <div
                  v-for="item in row.images"
                  :key="item.name"
                  style="
                    position: relative;
                    width: 60px;
                    height: 60px;
                    margin: 4px;
                  "
                >
                  <img
                    :src="item.url"
                    alt=""
                    style="width: 100%; height: 100%"
                  />
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            prop="actions"
            align="center"
            width="80px"
          >
            <template #default="{ $index }">
              <el-button
                size="small"
                type="danger"
                @click="handleRemoveNoData($index)"
                >移除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-button
          v-if="ndg_dialog.type === ConstEnum.sendBack"
          size="small"
          style="margin: 10px 0 20px; float: right"
          @click="clearRecallList"
          >重置当前退还列表数据</el-button
        >
      </template>
      <div style="margin-top: 20px">
        <el-button
          type="primary"
          :disabled="ndg_dialog.scan.length === 0"
          style="width: 100%"
          @click="toDealNdg"
          >确定{{
            ndg_dialog.type === ConstEnum.transfer ? "移交" : "退还"
          }}
          (共{{ ndg_dialog.scan.length }}件)</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="stop_dialog.show"
      :close-on-click-modal="false"
      title="提示"
      width="300px"
    >
      <div>{{ stop_dialog.msg }}</div>
      <div style="text-align: right; margin-top: 40px">
        <el-button type="danger" @click="stopRows(1, 1)">拦截</el-button>
        <el-button type="success" @click="stopRows(1, 2)">不拦截</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="recall_dialog"
      :close-on-click-modal="false"
      title="撤回包裹号"
      width="300px"
    >
      <el-input
        v-model="noDataPackageNo"
        placeholder="请输入包裹号"
        @keyup.native.enter="handleRecall"
      ></el-input>
    </el-dialog>
    <ys-camera
      v-model="isShowModalImages"
      :limit="ConstEnum.limitImage"
      :list="curItem.images"
      @complete="handleConfirmImages"
    ></ys-camera>
    <ys-camera
      v-model="isShowModalPhotos"
      :limit="ConstEnum.backLimitImage"
      :show-close="true"
      :is-show-close-btn="false"
      title="退还包裹拍照（限1张）"
      :camera-type="2"
      @complete="handleConfirmBackImages"
    >
      <!-- 拍照的title-->
      <template #header>
        <div>
          <p>商家：{{ supplyName }}</p>
          <p>包裹号：{{ noDataPackNo }}</p>
        </div>
      </template>
    </ys-camera>
    <!-- 打印面单 -->
    <lodop-print-for-no-data-package
      ref="printForNoDataPackageRef"
    ></lodop-print-for-no-data-package>
    <!-- 退还快递单号Dialog -->
    <el-dialog
      :visible.sync="returnShippingModalVisible"
      :close-on-click-modal="true"
      title="填写退还快递单号"
      width="500px"
      @close="handleReturnShippingModalClose"
    >
      <el-form
        ref="returnShippingFormRef"
        inline
        :model="returnShippingForm"
        :rules="shippingFormRules"
        label-width="130px"
      >
        <el-form-item label="无数据包裹号" prop="package_no">
          <el-input
            v-model="returnShippingForm.package_no"
            placeholder="扫描/输入无数据包裹号"
            @change="fetchNoDataInfoByPackageNo"
            @input="returnShippingForm.shipping_num = ''"
          ></el-input>
        </el-form-item>
        <el-form-item label="商家名称" prop="supply_name">
          <el-input
            v-model="returnShippingForm.supply_name"
            placeholder=""
            readonly
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="退还方式" prop="return_mode">
          <el-input
            v-model="returnShippingForm.return_mode"
            placeholder=""
            readonly
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="退还快递单号" prop="shipping_num">
          <el-input
            v-model="returnShippingForm.shipping_num"
            placeholder="请填写快递单号"
          ></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: right; margin-top: 40px">
        <el-button type="default" @click="handleReturnShippingModalClose">
          取消</el-button
        >
        <el-button type="primary" @click="handleReturnShipping">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="batchWithdrawDialog"
      :close-on-click-modal="false"
      title="撤回放行退还"
      width="500px"
    >
      <div>
        已选中{{
          batchWithdrawArr.length
        }}件无数据商品，请确认是否撤回至代采待处理？
      </div>
      <div style="text-align: right; margin-top: 40px">
        <el-button type="default" @click="batchWithdrawDialog = false">
          取消
        </el-button>
        <el-button type="primary" @click="submitBatchWithdraw">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="checkTipsDialog"
      :close-on-click-modal="false"
      title=""
      width="400px"
    >
      <div style="color: red">{{ noPassCheckIds }}</div>
      <div style="margin-top: 4px; font-size: 16px">
        为非待放行退还状态，不可撤回
      </div>
      <div style="text-align: right; margin-top: 40px">
        <el-button type="primary" @click="checkTipsDialog = false">
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import YsCamera from "@/components/YsComponents/YsCamera.vue";
import LodopPrintForNoDataPackage from "./components/lodopPrintForNoDataPackage.vue";
import {
  getNoDataInfoByNdgid,
  cloneNoDataPackageByPackageNo,
  makeNoDataPackageBackToSupply,
} from "@/controller/noDataPackage.js";
import apiBaseURL from "@/utils/baseUrl.js";
import * as warehouseConfigApi from "@/controller/warehouseConfig2278.js";
import * as defectiveApi from "@/openapi/erp/defective.js";
import {
  postGetPackageNoShippingInfo,
  postSaveShippingNum,
  postWithdrawBackToSupply,
  postGetNoDataInfoByNdgids,
} from "@/openapi/erp/noDataGoods.js";
import print from "@/mixins/print.js";

const ConstEnum = {
  transfer: 1, // 移交代采
  sendBack: 2, // 放行退还
  limitImage: 5,
  backLimitImage: 1, // 退还包裹拍照图片数量限制
};
const returnShippingFormDefaults = {
  package_no: "",
  supply_name: "",
  return_mode: "",
  shipping_num: "",
};
export default {
  components: { YsCamera, LodopPrintForNoDataPackage },
  mixins: [print],
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.$route.params.pg_member_id) {
        vm.$set(vm.form, "pg_member_id", vm.$route.params.pg_member_id);
      }
      if (vm.$route.params.data_time) {
        const tR = vm.$route.params.data_time.split("~");
        vm.$set(vm.form, "time", tR);
      }
      if (vm.$route.params.origin) {
        vm.origin = vm.$route.params.origin;
        vm.$set(vm.form, "origin", vm.origin);
      }
      vm.setSearchParamsFromQuery();
      vm.fetchData();
    });
  },
  data() {
    return {
      ConstEnum,
      resData: {
        count: 0,
        list: [],
      },
      form: {
        select_type: "ndgid",
        select_type_value: "",
        supply_name: "",
        pgid: [],
        pg_member_id: "",
        blp_type: "",
        time: this.$excalibur.getDateTimeOnHours(-15, 6),
        handle_time: [],
        handle_state: "",
        is_stop: "0",
        dh_type: "0",
        curPage: 1,
        page_size: 50,
        package_type: "",
        is_verify: "0",
        return_mode: "0",
        shipping_num: "",
        dg_member_ids: [],
      },
      filter: {
        optionPg: [],
        optionOrigin: [],
        optionHandleState: [],
        optionBlpType: [],
        optionDgMember: [],
      },
      select_type_option: [
        {
          label: "无数据标id",
          value: "ndgid",
        },
        {
          label: "批次单",
          value: "pici_no",
        },
        {
          label: "款号",
          value: "goods_kh",
        },
        {
          label: "货号",
          value: "goods_no",
        },
        {
          label: "创建人",
          value: "create_admin",
        },
        {
          label: "打标id",
          value: "dbid",
        },
        {
          label: "处理人",
          value: "handle_admin",
        },
        {
          label: "包裹号",
          value: "package_no",
        },
        {
          label: "无数据包裹号",
          value: "no_data_package_no",
        },
      ],
      loading: false, // 加载动画是否显示
      url: "/erp/NoDataGoods/noDataGoodsList",
      status: "",
      origin: 1,
      tableLoading: false,
      filterFold: false,
      logVisible: false,
      discard_form: {
        ndgid: "",
        invalid_note: "",
      },
      owe_data: {
        cg: 0,
        cgas: 0,
        as: 0,
      },
      dabiao_form: {
        qh_type: "",
        type: "",
        blp_type: "",
        blp_note: "",
      },
      multipleSelection: [],
      ndg_dialog: {
        show: false,
        type: ConstEnum.transfer, // {1:移交代采, 2:放行退还}
        scan: [], // 格式 { ndgid: String, images: [] }[]
        value: "",
      },
      // 拦截弹窗的
      stop_dialog: {
        show: false,
        msg: "",
      },
      recall_dialog: false,
      isShowModalImages: false,
      isShowModalPhotos: false,
      curIndex: "",
      curItem: [],
      withoutImagesIndex: -1, // 未填图片的行
      noDataPackageNo: "", // 无数据包裹号
      supplyInfo: {
        supply_id: "",
        supply_name: "",
      },
      action: `${apiBaseURL}/erp/NoDataGoods/ImportNoDataGoods`,
      // 放行退还打包的
      noDataPackNo: "", // 无数据包裹号
      supplyName: "", // 商家名称
      returnShippingModalVisible: false,
      returnShippingForm: { ...returnShippingFormDefaults },
      shippingFormRules: {
        package_no: [
          { required: true, message: "请输入无数据包裹号", trigger: "blur" },
        ],
        shipping_num: [
          { required: true, message: "请输入退还快递单号", trigger: "blur" },
        ],
      },
      batchWithdrawDialog: false,
      batchWithdrawArr: [],
      checkTipsDialog: false,
      noPassCheckIds: "",
    };
  },
  created() {
    this.getFilter();
    this.getDgMemberFilter();
  },
  methods: {
    setSearchParamsFromQuery() {
      console.log("this.$route.query:", this.$route.query);
      const {
        from_source: fromSource = "",
        pg_group_id: pgGroupId = [],
        pg_member_id: pgMemberId = [],
        package_no: packageNo = "",
        supply_name: supplyName = "",
        package_type: packageType = "",
      } = this.$route.query;
      this.form.pgid = Array.isArray(pgGroupId)
        ? pgGroupId
        : pgGroupId.split(",").filter(Boolean);
      this.form.pg_member_id = Array.isArray(pgMemberId)
        ? pgMemberId
        : pgMemberId.split(",").filter(Boolean);

      this.form.select_type = packageNo ? "package_no" : this.form.select_type;
      this.form.select_type_value = packageNo || this.form.select_type_value;
      this.form.package_type = packageType || this.form.package_type;
      this.form.supply_name = supplyName || this.form.supply_name;
      // fromSource === "1" 表示从入库差异处理详情页跳转过来
      this.form.time = fromSource === "1" ? [] : this.form.time;
    },
    tableRowClassName({ rowIndex }) {
      if (rowIndex === this.withoutImagesIndex) {
        return "danger-row";
      }
      return "";
    },
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.form).then((res) => {
        this.form.is_excel = 0;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    fetchData(showLoading) {
      this.multipleSelection = [];
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.form).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    getFilter() {
      this.$http
        .post("/erp/NoDataGoods/getNoDataGoodsListFilter", {})
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error("数据加载失败,请刷新页面");
          } else {
            this.filter = res.data.data;
          }
        });
    },
    getDgMemberFilter() {
      const params = {
        p: 1,
        psize: 99999,
        status: 1,
      };
      defectiveApi.postGetMembers(params).then((res) => {
        console.log("postGetMembers res:", res);
        const optionDgMember = res.list.map((item) => {
          return {
            label: item.admin_name,
            value: item.dg_member_id,
          };
        });
        console.log("optionDgMember:", optionDgMember);
        this.filter.optionDgMember = optionDgMember;
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onSubmit() {},
    handleCurrentChange(val) {
      this.form.page = val;
      this.loading = true;
      this.$http.post(this.url, this.form).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.fetchData();
    },

    selectStatus(key) {
      this.form.origin = this.origin = key;
      this.loading = true;
      this.$http.post(this.url, this.form).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    discard(row) {
      this.$prompt("请输入作废理由", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputType: "textarea",
      }).then(({ value }) => {
        this.discard_form.ndgid = row.ndgid;
        this.discard_form.invalid_note = value;
        this.$http
          .post("/erp/NoDataGoods/discard", this.discard_form)
          .then((res) => {
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.$message.success("作废成功");
              this.fetchData(true);
            }
          });
      });
    },
    // 拦截
    toStop(ndgids, is_stop) {
      return new Promise((resolve) => {
        this.$http
          .post("/erp/NoDataGoods/stopNoDataGoods", {
            ndgids,
            is_stop,
          })
          .then((rs) => {
            if (rs.data.code !== 200) return this.$message.error(rs.data.msg);
            this.$message.success("操作成功");
            this.fetchData();
            resolve();
          });
      });
    },

    // 单行拦截
    stopRow(row_index) {
      this.toStop(
        [this.resData.list[row_index].ndgid],
        this.resData.list[row_index].is_stop
      );
    },

    // 批量拦截
    stopRows(is_commit, action) {
      const post = [];
      this.multipleSelection.forEach((v) => {
        if (["1", "2"].includes(v.handle_state)) {
          post.push(v.ndgid);
        }
      });
      if (post.length === 0) {
        return this.$alert("请选勾选无数据商品, 或检查勾选的商品状态");
      }
      this.$set(
        this.stop_dialog,
        "msg",
        `已选中${post.length}件无数据商品, 请选择处理方式`
      );
      this.$set(this.stop_dialog, "show", true);
      if (is_commit) {
        this.toStop(post, action).then(() => {
          this.$set(this.stop_dialog, "show", false);
        });
      }
    },

    // 放行退还 // 移交代采
    showNdgDialog(type) {
      this.$set(this.ndg_dialog, "type", type);
      this.$set(this.ndg_dialog, "show", true);
      this.$set(this.ndg_dialog, "scan", []);
      if (type === 2 && this.multipleSelection.length !== 0) {
        this.handleGetNoDataInfoByNdgids();
      }
      // // 点击「放行退还打包」时，判断是否有有勾选的“无数据标id”， 存在id则将全部id代入
      // if (type === 2) {
      //   this.$set(this.ndg_dialog, "scan", this.multipleSelection);
      // } else {
      //   this.$set(this.ndg_dialog, "scan", []);
      // }

      this.$nextTick(() => {
        this.$refs.scanNdgidRef.focus();
      });
    },
    //  撤回包裹
    handleRecall() {
      // this.recall_dialog = false
      cloneNoDataPackageByPackageNo({ noDataPackageNo: this.noDataPackageNo })
        .then(() => {
          this.$message.success("撤回成功");
          this.fetchData();
        })
        .catch(this.$noop);
    },
    // 扫描确定
    scanPush() {
      // 移交代采
      const { value, scan, type } = this.ndg_dialog;
      this.$set(this.ndg_dialog, "value", "");
      if (scan.some((item) => item.ndgid === value)) {
        this.$message.e("重复扫码");
        return;
      }
      if (scan.length > 100) {
        this.$message.e("一次操作请勿超过一百个无数据ID");
        return;
      }
      if (type === 1) {
        //  移交代采
        this.moveToPurchase(value);
      } else {
        // 根据无数据id获取详情
        this.getNoDataInfoByNdgid(value);
      }
    },
    //  移交代采
    moveToPurchase(value) {
      this.$http
        .post(`/erp/NoDataGoods/checkNdgidOnMoveToPurchase`, { ndgid: value })
        .then((rs) => {
          if (rs.data.code !== 200) return this.$message.e(rs.data.msg);
          this.ndg_dialog.scan.push({ ndgid: value, images: [] });
        });
    },
    async makeNoDataPackageBackToSupply(params) {
      try {
        const res = await makeNoDataPackageBackToSupply(params);

        const {
          no_data_package_no: noDataPackNo,
          supply_name: supplyName,
          shipping_printData: shippingPrintData,
        } = res;

        this.noDataPackNo = noDataPackNo;
        this.supplyName = supplyName;
        const contents = res;
        // 如果存在 快递面单数据 则打印快递面单
        if (shippingPrintData) {
          this.doPrint(shippingPrintData.print_data);
        }
        // 确定退还 打印单
        this.$refs.printForNoDataPackageRef.calling(contents);
        // // 点击确定退还后 进行打包，返回无数据包裹号，弹出照片的框
        this.isShowModalPhotos = true;
        this.$set(this.ndg_dialog, "show", false);
        this.supplyInfo = {};
        this.fetchData();
        if (res.msg) {
          this.$message.error(res.msg);
        }
      } catch (error) {
        this.$message.error(error.msg);
      }
    },
    // 根据无数据id获取详情
    getNoDataInfoByNdgid(ndgid) {
      const params = {
        ndgid,
        supplyId: this.supplyInfo.supply_id || 0,
        return_mode: this.supplyInfo.return_mode || 0,
      };
      getNoDataInfoByNdgid(params)
        .then((res) => {
          const { supplyInfo, noDataInfo } = res.data;
          if (!this.supplyInfo.supply_name) {
            this.supplyInfo = supplyInfo;
          }
          this.ndg_dialog.scan.push({
            ndgid: noDataInfo.ndgid,
            images: noDataInfo.img,
          });
        })
        .catch(this.$noop);
    },

    // 重置
    clearRecallList() {
      this.ndg_dialog.scan = [];
      this.supplyInfo = this.$options.data.call(this).supplyInfo;
    },
    // 删除一个
    scanPop(ndgid) {
      const idx = this.ndg_dialog.scan.findIndex(
        (item) => item.ndgid === ndgid
      );
      if (idx === -1) {
        return this.$message.e("这个无数据ID不在已扫描列表内");
      }
      this.ndg_dialog.scan.splice(idx, 1);
    },

    // 确定退还/移交
    toDealNdg() {
      const { type, scan } = this.ndg_dialog;
      if (type === 1) {
        //  确定移交
        const url = { 1: "moveToPurchase", 2: "backToSupply" }[type];
        const withoutImagesData = scan.find((item) => !item.images.length);
        const withoutImagesIndex = scan.findIndex(
          (item) => !item.images.length
        );
        if (type === ConstEnum.transfer && withoutImagesData) {
          this.withoutImagesIndex = withoutImagesIndex;
          this.$message.info(
            `无数据ID ${withoutImagesData.ndgid} 未添加图片的，请补充后提交`
          );
          return;
        }
        const params = {
          1: {
            ndgids_data: JSON.stringify(
              scan.map((item) => {
                return {
                  ...item,
                  images: item.images.map((item) => item.name),
                };
              })
            ),
          },
          2: {
            ndgids: scan.map((item) => item.ndgid),
          },
        }[type];
        this.$http.post(`/erp/NoDataGoods/${url}`, params).then((rs) => {
          if (rs.data.code !== 200) {
            return this.$message.error(rs.data.msg);
          }
          this.$set(this.ndg_dialog, "show", false);
          this.fetchData();
        });
      } else {
        const params = {
          ndgid: scan.map((item) => item.ndgid).toString(),
        };
        this.makeNoDataPackageBackToSupply(params);
      }
    },
    beforeImport(file) {
      console.log("before upload");
      console.log(file);
      return true;
    },
    handleImport(response) {
      if (response.code === 200) {
        const { result } = response.data;
        if (result) {
          // 去重防止重复导入
          const { scan } = this.ndg_dialog;
          const ndgidList = scan.map((item) => item.ndgid);
          const addIdList = response.data.list.filter(
            (item) => !ndgidList.includes(item)
          );
          const combineList = addIdList.map((item) => {
            return {
              ndgid: item,
              images: [],
            };
          });
          this.$set(this.ndg_dialog, "scan", [...scan, ...combineList]);
          this.$message.success("导入完成");
        } else {
          this.$message.e("导入失败，开始下载错误文件");
          window.open(apiBaseURL + response.data.error_file);
        }
      } else {
        this.$message.e(response.msg);
      }
    },
    handleRemoveNoData(index) {
      this.ndg_dialog.scan.splice(index, 1);
      if (this.withoutImagesIndex === index) {
        this.withoutImagesIndex = -1;
      }
      this.$nextTick(() => {
        if (this.ndg_dialog.scan.length === 0) {
          this.supplyInfo = this.$options.data.call(this).supplyInfo;
        }
      });
    },
    handleDelImages(pIndex, index) {
      const item = this.ndg_dialog.scan[pIndex];
      item.images.splice(index, 1);
      this.ndg_dialog.scan.splice(pIndex, 1, item);
    },
    handleEditImages(row, index) {
      this.curIndex = index;
      this.curItem = row;
      this.isShowModalImages = true;
    },
    handleConfirmImages(images) {
      console.log("----images", images);
      this.ndg_dialog.scan.splice(this.curIndex, 1, {
        ...this.curItem,
        images,
      });
      if (images.length && this.curIndex === this.withoutImagesIndex) {
        this.withoutImagesIndex = -1;
      }
    },
    handleConfirmBackImages(images) {
      const packageImg = images[0].name;
      const params = {
        package_img: packageImg,
        no_data_package_no: this.noDataPackNo,
      };
      warehouseConfigApi
        .saveNoDataPackageImg(params)
        .then((res) => {
          console.log("成功绑定包裹号和图片", res);
        })
        .catch(this.$noop);
    },
    handleViewImages(images) {
      this.$viewerApi({
        images,
      });
    },
    showReturnShippingModal() {
      this.returnShippingModalVisible = true;
    },
    handleReturnShipping() {
      // check if form is valid.
      this.$refs.returnShippingFormRef.validate((valid) => {
        if (!valid) {
          return;
        }
        const { package_no: packageNo, shipping_num: shippingNum } =
          this.returnShippingForm;
        const params = {
          no_data_package_no: packageNo,
          shipping_num: shippingNum,
        };
        this.returnShippingModalVisible = false;
        this.returnShippingForm = { ...returnShippingFormDefaults };
        this.$refs.returnShippingFormRef.resetFields();
        postSaveShippingNum(params).then(() => {
          this.$message.success("保存成功");
          this.fetchData();
        });
      });
    },
    fetchNoDataInfoByPackageNo() {
      postGetPackageNoShippingInfo({
        no_data_package_no: this.returnShippingForm.package_no,
      })
        .then((res) => {
          this.returnShippingForm = res;
        })
        .catch(() => {
          console.log("🚀 : fetchNoDataInfoByPackageNo : catch:");
          this.returnShippingForm = { ...returnShippingFormDefaults };
        })
        .finally(() => {
          this.$refs.returnShippingFormRef.clearValidate();
        });
    },
    handleReturnShippingModalClose() {
      this.returnShippingModalVisible = false;
      this.returnShippingForm = { ...returnShippingFormDefaults };
      this.$refs.returnShippingFormRef.resetFields();
    },
    // 批量撤回放行退还
    handleBatchWithdraw() {
      // 初始化数据
      const noPassCheck = [];
      this.batchWithdrawArr = [];

      this.multipleSelection.forEach((v) => {
        if (!["9"].includes(v.handle_state)) {
          noPassCheck.push(v.ndgid);
        } else {
          this.batchWithdrawArr.push(v.ndgid);
        }
      });

      if (this.multipleSelection.length === 0) {
        return this.$alert("请勾选无数据商品");
      }
      if (noPassCheck.length > 0) {
        this.noPassCheckIds = noPassCheck.join(",");
        this.checkTipsDialog = true;
        return false;
      }
      this.batchWithdrawDialog = true;
      return false;
    },
    // 提交绑定
    submitBatchWithdraw() {
      postWithdrawBackToSupply({ ngdid_arr: this.batchWithdrawArr }).then(
        () => {
          this.$message.success("操作成功");
          // 刷新页面
          this.fetchData();
          this.batchWithdrawDialog = false;
        }
      );
    },
    // 根据无数据ids获取详情
    handleGetNoDataInfoByNdgids() {
      const params = {
        ndgids: this.multipleSelection.map((item) => item.ndgid),
      };
      postGetNoDataInfoByNdgids(params)
        .then((res) => {
          const { supplyInfo, noDataInfo } = res;
          if (!this.supplyInfo.supply_name) {
            this.supplyInfo = supplyInfo;
          }
          this.ndg_dialog.scan = noDataInfo.map((item) => {
            return {
              ndgid: item.ndgid,
              images: item.img,
            };
          });
        })
        .catch(this.$noop);
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.red {
  background-color: red;
}

.green {
  background-color: green;
}

::v-deep .el-table .danger-row {
  background: #e6a23c;
}

.print-content {
  width: 80%;
  box-sizing: border-box;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/nodatagoods/NoDataGoodsList.vue